(function (app, ng) {

    app.config([
        '$stateProvider', function ($stateProvider) {
            $stateProvider.state('Home.Tools.MarketingTrackerNew.Dashboard',
                {
                    url: '/Dashboard/:SalesYear',
                    component: 'salesTrackerDashboardComponent',
                    PageTitle: 'Dashboard | Marketing Tracker',
                });
        }
    ]);

    app
        .component('salesTrackerDashboardComponent',
            {
                templateUrl: 'App/Tools/MarketingTrackerNew/Dashboard/Dashboard.template.html',
                controller: 'SalesTrackerDashboardController',
                bindings: {
                    user: '<',
                    currentYear: '<',
                    years: '<',
                }
            })
        .controller('SalesTrackerDashboardController',
            ['_', 'marketingTrackerSalesTrackerDashboardApi', '$state',
                function (_, marketingTrackerSalesTrackerDashboardApi, $state) {
                    var $ctrl = this;

                    ng.extend($ctrl, {
                        ui: {},
                        endDate: null,
                        startDate: null
                    });

                    function _resetTimeFrame (timeFrame) {
                        $ctrl.endDate = !!timeFrame
                            ? moment().set({ 'year': timeFrame }).endOf('year').format('YYYY-MM-DD')
                            : moment().endOf('year').utc().format('YYYY-MM-DD');
                        $ctrl.startDate = !!timeFrame
                            ? moment().set({ 'year': timeFrame }).startOf('year').format('YYYY-MM-DD')
                            : moment().startOf('year').utc().format('YYYY-MM-DD');
                    }
                    $ctrl.goToYear = function () {
                        var params = ng.copy($state.params);
                        params.SalesYear = $ctrl.salesYear;
                        var currentState = $state.current.name;
                        $state.go(currentState, params);
                        _resetTimeFrame($ctrl.salesYear);
                    }

                    $ctrl.$onInit = function () {
                        $ctrl.salesYear = parseInt($state.params.SalesYear);
                        _resetTimeFrame($ctrl.salesYear);
                        marketingTrackerSalesTrackerDashboardApi.userSignIn().then(function (response) {
                        })
                        
                    }
                }
            ]);
})(window.app, window.angular); //jshint ignore:line